import { render, staticRenderFns } from "./MyChoir.vue?vue&type=template&id=2160c86c&scoped=true&"
import script from "./MyChoir.vue?vue&type=script&lang=ts&"
export * from "./MyChoir.vue?vue&type=script&lang=ts&"
import style0 from "./MyChoir.vue?vue&type=style&index=0&id=2160c86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2160c86c",
  null
  
)

export default component.exports